export default __webpack_public_path__ + "img/d50e54494ad3c075eb904a90a7b199b3.jpg";